import * as Connector from 'shared/connectors/settlementConnector';
import { SETTLEMENTS } from 'store/types';

const init = () => ({
  type: SETTLEMENTS.GET_PLOTS_INIT,
});

export const success = plots => ({
  type: SETTLEMENTS.GET_PLOTS_SUCCESS,
  payload: {
    plots,
  },
});

const failure = () => ({
  type: SETTLEMENTS.GET_PLOTS_FAILURE,
});

const getPlots = params => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getPlots(params);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getPlots;
